import { GiftOffOutlineIcon } from './GiftOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E1260280-2F0F-4D7D-AA15-0322C8699541
 * name gift-off-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gift-off-outline.svg
 * tags
 * - Holiday 
 */
export const DonateOffOutlineIcon = GiftOffOutlineIcon;
export default DonateOffOutlineIcon